import { useAsync } from '@nuxtjs/composition-api'

import { useProductStore } from '~/store/product'
import { useCMSContentFragmentsStore, useCMSContentTargetsStore } from '~/store/cms'

export function useContentTarget(devkey: string) {
  const contentFragmentsStore = useCMSContentFragmentsStore()
  const contentTargetsStore = useCMSContentTargetsStore()
  const { currentProduct } = useProductStore()

  const listOfFragments = useAsync(async () => {
    try {
      await contentTargetsStore.fetchContentTarget(devkey)

      return (
        contentTargetsStore.getByDevKey(devkey, currentProduct)?.map((component) => ({
          html: contentFragmentsStore.html(component.uid),
          componentType: component.componentType,
        })) ?? []
      )
    } catch (err: unknown) {
      console.error(err)
      return []
    }
  }, devkey)

  return { listOfFragments }
}
